import { createFileRoute, redirect } from '@tanstack/react-router'

/** `/` lands on the dashboard. An operator console has no marketing page of its own. */
export const Route = createFileRoute('/_authenticated/')({
  beforeLoad: () => {
    throw redirect({ to: '/dashboard' })
  },
})
